import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  save_car_destails,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery";
import Loader from "./Loader";

function AddNewGuestCar({
  addIPassModalOpen,
  setAddIPassModalOpen,
  handleCallData,
}) {
  const [errors, setErrors] = useState({});
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const currentYear = new Date().getFullYear();
  const [formData, setFormData] = useState({
    carName: "",
    modelYear: "",
    vin: "",
    licensePlate: "",
    driverName: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setErrors({});
    setAddIPassModalOpen(false);
    setFormData({
      carName: "",
      modelYear: "",
      vin: "",
      licensePlate: "",
      driverName: "",
    });
  };

  const validate = (data) => {
    const err = {};

    if (!data.carName || data.carName.trim() === "") {
      err.carName = "Car name is required.";
    }

    if (!data.modelYear || data.modelYear.trim() === "") {
      err.modelYear = "Model year is required.";
    } else if (!/^\d{4}$/.test(data.modelYear)) {
      err.modelYear = "Model year must be a 4-digit number.";
    } else if (parseInt(data.modelYear, 10) > currentYear) {
      err.modelYear = `Model year cannot be greater than ${currentYear}.`;
    }

    if (!data.vin || data.vin.trim() === "") {
      err.vin = "VIN is required.";
    } else if (data.vin.trim().length !== 17) {
      err.vin = "VIN must be exactly 17 characters.";
    }

    if (!data.licensePlate || data.licensePlate.trim() === "") {
      err.licensePlate = "License plate number is required.";
    }

    if (!data.driverName || data.driverName.trim() === "") {
      err.driverName = "Driver name is required.";
    }

    setErrors(err);

    // return true when no errors
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async () => {
    console.log("newForm");
    if (!validate(formData)) {
      console.log("newForm-invalid");
      const firstInvalid = document.querySelector(".is-invalid");
      if (firstInvalid) firstInvalid.focus();
      return;
    }

    try {
      // Reset form and close modal on success
      setFormData({
        carName: "",
        modelYear: "",
        vin: "",
        licensePlate: "",
        driverName: "",
      });
      setErrors({});
      setAddIPassModalOpen(false);
      handleCancel?.();
    } catch (apiErr) {
      console.error("API error while saving guest car:", apiErr);
    }
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    if (!validate(formData)) {
      console.log("newForm-invalid");
      const firstInvalid = document.querySelector(".is-invalid");
      if (firstInvalid) firstInvalid.focus();
      return;
    }
    let fd_from = new FormData();
    fd_from.append("make_year", formData.modelYear);
    fd_from.append("vin", formData.vin);
    fd_from.append("carName", formData.carName);
    fd_from.append("carNo", formData.licensePlate);
    fd_from.append("car_driver_name", formData.driverName);
    fd_from.append("car_guest_running", "guest");
    // Sending the data to the server
    await server_post_data(save_car_destails, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          // handleSuccessSession(Response.data.message, "/view_cardetails");
          handleSuccess(Response.data.message);
          setFormData({
            carName: "",
            modelYear: "",
            vin: "",
            licensePlate: "",
            driverName: "",
          });
          handleCallData();
          setErrors({});
          setAddIPassModalOpen(false);
          handleCancel?.();
        }
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };
  return (
    <>
      {showLoaderAdmin && <Loader />}
      <Modal
        show={addIPassModalOpen}
        onHide={() => setAddIPassModalOpen(false)}
        size="lg"
        centered
        className="ipass-modal"
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>Add New/Guest Car</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="container-fluid p-0">
            <div className="">
              <div className="col-lg">
                <div className="ipass-form-container">
                  <h3 className="h5 mb-4">Guest Car Details</h3>

                  <form>
                    <div className="row m-0">
                      <div className="col-sm-6 mb-3">
                        <label
                          htmlFor="carName"
                          className="form-label ipass-form-label"
                        >
                          Car Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.carName ? "is-invalid" : ""
                          }`}
                          id="carName"
                          name="carName"
                          value={formData.carName}
                          onChange={handleChange}
                          placeholder="e.g. Toyota Innova / Hyundai Creta"
                          required
                        />
                        {errors.carName && (
                          <div className="invalid-feedback">
                            {errors.carName}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label
                          htmlFor="modelYear"
                          className="form-label ipass-form-label"
                        >
                          Model Year <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className={`form-control ${
                            errors.modelYear ? "is-invalid" : ""
                          }`}
                          id="modelYear"
                          name="modelYear"
                          min="1900"
                          max={new Date().getFullYear()}
                          value={formData.modelYear}
                          onChange={handleChange}
                          placeholder="e.g. 2020"
                          required
                        />
                        {errors.modelYear && (
                          <div className="invalid-feedback">
                            {errors.modelYear}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label
                          htmlFor="vin"
                          className="form-label ipass-form-label"
                        >
                          VIN (Vehicle Identification Number){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.vin ? "is-invalid" : ""
                          }`}
                          id="vin"
                          name="vin"
                          value={formData.vin}
                          onChange={handleChange}
                          placeholder="Enter VIN (17 characters preferred)"
                          maxLength={17}
                          required
                        />
                        {errors.vin && (
                          <div className="invalid-feedback">{errors.vin}</div>
                        )}
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label
                          htmlFor="licensePlate"
                          className="form-label ipass-form-label"
                        >
                          License Plate Number{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.licensePlate ? "is-invalid" : ""
                          }`}
                          id="licensePlate"
                          name="licensePlate"
                          value={formData.licensePlate}
                          onChange={handleChange}
                          placeholder="e.g. MH12AB1234"
                          required
                        />
                        {errors.licensePlate && (
                          <div className="invalid-feedback">
                            {errors.licensePlate}
                          </div>
                        )}
                      </div>

                      <div className="col-sm-6 mb-3">
                        <label
                          htmlFor="driverName"
                          className="form-label ipass-form-label"
                        >
                          Driver Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.driverName ? "is-invalid" : ""
                          }`}
                          id="driverName"
                          name="driverName"
                          value={formData.driverName}
                          onChange={handleChange}
                          placeholder="Driver full name"
                          required
                        />
                        {errors.driverName && (
                          <div className="invalid-feedback">
                            {errors.driverName}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "var(--primary-color)", border: "none" }}
            onClick={() => handleSaveChangesdynamic(formData)}
          >
            Save Car
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddNewGuestCar;
